import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const exportPDF = () => {
    const contentToExport = document.getElementById('contentToExport');
    // Add a class to the main container and the specific table container to ensure styles are overridden
    contentToExport.classList.add('pdf-export-content'); 
    document.querySelector('.table').classList.add('pdf-export-content');
  
    html2canvas(contentToExport, { 
      scale: 1,
      useCORS: true,
      onclone: (document) => {
        // Ensuring all parts of the document are visible in the clone used by html2canvas
        document.getElementById('contentToExport').style.overflow = 'visible';
        document.querySelector('.table').style.overflow = 'visible';
      }
    })
    .then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF({
        orientation: 'landscape',
        unit: 'px',
        format: [canvas.width, canvas.height]
      });
      pdf.addImage(imgData, 'PNG', 0, 0);
      pdf.save('download.pdf');
      // Remove the temporary class after export
      contentToExport.classList.remove('pdf-export-content'); 
      document.querySelector('.table').classList.remove('pdf-export-content');
    })
    .catch(error => {
      console.error('Error during PDF export:', error);
      // Ensure class is removed even if export fails
      contentToExport.classList.remove('pdf-export-content');
      document.querySelector('.table').classList.remove('pdf-export-content');
    });
  };
  
export default exportPDF;